module.exports = __webpack_public_path__ + "img/twitch.b5bd7945.svg";